import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;

// Firebase config yoksa (CI/test ortamı) boş auth nesnesi kullan
const firebaseConfig = {
  apiKey,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:  import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId:      import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = (apiKey && getApps().length === 0)
  ? initializeApp(firebaseConfig)
  : getApps()[0];

export const firebaseAuth = app ? getAuth(app) : null;
export const firebaseConfigured = !!apiKey;
